// extracted by mini-css-extract-plugin
export var centerText = "_e1-8";
export var container = "_e1-0";
export var doughnutContainer = "_e1-7";
export var legend = "_e1-a";
export var legendItemColorDisplay = "_e1-b";
export var legendItemLabel = "_e1-d";
export var legendItemValue = "_e1-c";
export var lg = "_e1-5";
export var maxWidth = "_e1-9";
export var md = "_e1-4";
export var responsive = "_e1-6";
export var sm = "_e1-3";
export var xs = "_e1-2";
export var xxs = "_e1-1";